import React from 'react';

export const RecommendedRecruiters = () => {
    return (
        <div className='vacancy-confirmation-page__section'>
            {/* <div className='vacancy-confirmation-page__section-title-wrap'>
                <h3 className='vacancy-confirmation-page__section-title'>{__t('Рекомендованные агентства')}</h3>
                <a href='' className='count-link'>
                    <span className='count-link__text'>{__t('Все агенства')}</span>
                    <span className='count-link__count'>2 560</span>
                    <span className='count-link__icon'>
                        <i aria-hidden='true' className='icon-arrow-right'></i>
                    </span>
                </a>
            </div>

            <div className='cards-container'>
                <div className='card-item agency-card-small'>
                    <div className='card-item__content'>
                        <div className='card-item__favorites-button'>
                            <div className='favorites-button' data-url='/cv/favorite-toggle'>
                                <div className='hover-tooltip'>
                                    <button className='favorites-button__icon hover-tooltip__icon'>
                                        <i aria-hidden='true' className='icon-star-light'></i>
                                        <i aria-hidden='true' className='icon-star-solid'></i>
                                    </button>
                                    <div className='hover-tooltip__text favorites-button__text'>
                                        {__t('Добавить в избранное')}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='agency-card-small__name'>HR агентство DOVGAN & CO</div>

                        <div className='card-info-item card-item__info-item'>
                            <i aria-hidden='true' className='icon-building-light i-default'></i>
                            <span className='card-info-item__text'>{__t('Агентство')}</span>
                        </div>

                        <div className='card-info-item card-item__info-item'>
                            <i aria-hidden='true' className='icon-user-tie-hair-light i-default'></i>
                            <span className='card-info-item__text'>{__t('Частный рекрутер')}</span>
                        </div>

                        <div className='card-info-item card-item__info-item'>
                            <i aria-hidden='true' className='icon-location-dot-light i-default'></i>
                            <span className='card-info-item__text'>Киев, Украина</span>
                        </div>

                        <div className='tooltip-popup'>
                            <div className='card-info-item card-info-item--with-tooltip card-item__info-item tooltip-popup__activate-button'>
                                <i aria-hidden='true' className='icon-file-check-light i-default'></i>
                                <span className='card-info-item__text'>{__t('Смотреть контакты')}</span>
                            </div>

                            <div className='tooltip-popup__overlay'></div>
                            <div className='tooltip-popup__popup-container'>
                                <div className='tooltip-popup__flex-wrap'>
                                    <div className='tooltip-popup__popup-content'>
                                        <div className='card-contact-info'>
                                            <i
                                                aria-hidden='true'
                                                className='icon-mobile-screen-light card-contact-info__icon i-default'
                                            ></i>
                                            <div className='card-contact-info__content'>
                                                <div className='card-contact-info__value'>
                                                    <a href='tel:+48535994839'>+48 535 994 839</a>
                                                    {/* <?= Html::img($this->theme->getUrl('img/messenger_icons/viber-small.svg')) ?>
                                        <?= Html::img($this->theme->getUrl('img/messenger_icons/whatsapp-small.svg')) ?>
                                        <?= Html::img($this->theme->getUrl('img/messenger_icons/telegram-small.svg')) ?> 
                                                </div>
                                                <div className='card-contact-info__name'>Татьяна</div>
                                            </div>
                                        </div>
                                    </div>
                                    <i aria-hidden='true' className='icon-times tooltip-popup__close'></i>
                                </div>
                            </div>
                        </div>

                        <div className='card-item__section-title'>{__t('Трудоустраиваем в')}</div>

                        <div className='tooltip-popup'>
                            <div className='card-info-item card-info-item--with-tooltip card-item__info-item tooltip-popup__activate-button'>
                                {/* <?= Html::img($this->theme->getUrl('img/flags/eu.svg')) ?> 
                                <span className='card-info-item__text'>{__t('Все страны')}</span>
                            </div>

                            <div className='tooltip-popup__overlay'></div>
                            <div className='tooltip-popup__popup-container'>
                                <div className='tooltip-popup__flex-wrap'>
                                    <div className='tooltip-popup__popup-content'>
                                        {/* <!-- TODO: Add countries --> 
                                    </div>
                                    <i aria-hidden='true' className='icon-times tooltip-popup__close'></i>
                                </div>
                            </div>
                        </div>

                        <div className='tooltip-popup'>
                            <div className='card-info-item card-info-item--with-tooltip card-item__info-item tooltip-popup__activate-button'>
                                <i aria-hidden='true' className='icon-user-helmet-safety-light i-default'></i>
                                <span className='card-info-item__text'>{__t('Все сферы')}</span>
                            </div>

                            <div className='tooltip-popup__overlay'></div>
                            <div className='tooltip-popup__popup-container'>
                                <div className='tooltip-popup__flex-wrap'>
                                    <div className='tooltip-popup__popup-content'>{/* <!-- TODO: Add Areas --> </div>
                                    <i aria-hidden='true' className='icon-times tooltip-popup__close'></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <a href='' className='button-main button-main--bordered vacancy-confirmation-page__mobile-button'>
                <span className='count-link__text'>{__t('Все агенства')}</span>
                <span className='count-link__count'>1 321</span>
            </a> */}
        </div>
    );
};
